<template>
    <v-dialog v-model="show" max-width="500" scrollable overlay-color="#000" overlay-opacity="0.8">
        <v-card>
            <template v-if="questionDetails">
                <v-card-title class="d-flex justify-space-between mb-3">
                    <div>تفاصيل السؤال #{{questionDetails.id}}</div>
                    <div style="margin-left: -10px">
                        <v-btn icon color="muted" @click="show = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>
                <v-card-subtitle>
                    <div class="d-flex ">
                        <v-chip v-for="category in questionDetails.categories" color="grey lighten-4" :key="category.id" small label class="me-1"> <!-- :href="'/exams/questions/directories/' + category.id"  -->
                            <v-icon small color="blue darken-2" left class="me-2">mdi-folder</v-icon>
                            <span>{{category.name}}</span>
                        </v-chip>

                        <question-difficulty :level="questionDetails.difficulty_level" />
                        
                        <v-chip v-if="questionDetails.type === 'essay'" color="grey lighten-4" small label class="me-1 px-2">
                            <v-icon size="15" class="me-1">mdi-card-text-outline</v-icon>
                            <span>سؤال مقالي</span>
                        </v-chip>
                    </div>
                </v-card-subtitle>
                <v-card-text>
                    <v-card text class="bordered grey lighten-4" flat>
                        <v-card-text style="font-size: 15px; line-height: 1.6; whitespace: pre-wrap;">
                            <div class="strong-text--text">
                                {{questionDetails.text}}
                            </div>
                        </v-card-text>
                    </v-card>
                    <div v-if="questionDetails.image_url" class="my-4 bordered pa-3">
                        <v-img contain :src="questionDetails.image_url" rounded></v-img>
                    </div>
                    <!-- <v-divider class="my-2"></v-divider> -->
                    <div v-if="questionDetails.type !== 'essay'">
                        <v-list class="transparent pa-0 ma-0">
                            <v-subheader class="mt-2 mb-1" style="height: auto">اﻹجابات</v-subheader>
                            <v-list-item v-for="answer in questionDetails.answers" :key="answer.id" class="mb-2 lighten-5" :class="{'green': answer.correct, 'grey': !answer.correct}">
                                <v-list-item-icon>
                                    <v-icon v-if="answer.correct" color="success" size="26">mdi-check-circle</v-icon>
                                    <v-icon v-else color="error" size="26">mdi-close-circle-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title class="strong-text--text">
                                    <div class="d-flex pa-2" v-if="answer.image_url">
                                        <img :src="answer.image_url" style="max-height: 75px; max-width: 100%"/>
                                    </div>
                                    <div v-else>{{answer.text}}</div>
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </div>

                    <div v-if="questionDetails.answer_explain_text || questionDetails.answer_explain_image">
                    <v-divider class="mt-5"></v-divider>
                        <v-subheader class="strong-text--text py-0 px-0">توضيح إجابة السؤال <span class="muted--text ms-2">(تظهر للطالب مع تصحيح الإجابات)</span></v-subheader>
                        <div v-if="questionDetails.answer_explain_text" class="pa-3 grey lighten-3 text--text rounded mb-3" style="font-size: 14px; line-height: 1.6; whitespace: pre-wrap;">{{questionDetails.answer_explain_text}}</div>
                        <div v-if="questionDetails.answer_explain_image" class="mb-3 pa-3">
                            <v-img contain :src="questionDetails.answer_explain_image" rounded style="max-height: 300px;"></v-img>
                        </div>
                    </div>
                </v-card-text>
            </template>
        </v-card>
    </v-dialog>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import QuestionDifficulty from './question-difficulty'

export default {
    props: {
        value: {},
        questionDetails: {},
    },
    components: {QuestionDifficulty},
    data(){
        return {
            show: false,
        }
    },
    computed: {
        ...GlobalComputed,

    },
    watch: {
        show(show){
            if (!show){
                this.$emit('input', false); // close
            }
        },
        value(show){
            this.show = show;
        },
    },
    methods: {
        ...GlobalMethods,
    },
    mounted(){

    }
}
</script>

<style>

</style>
